import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Navigate } from 'react-router';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { lightTheme, darkTheme } from './theme';
import LoginPage from './pages/LoginPage';
import SeasonsPage from './pages/SeasonsPage';
import SeasonFormPage from './pages/SeasonFormPage';
import EditSeasonPage from './pages/EditSeasonPage';
import SeasonDashboardPage from './pages/SeasonDashboardPage';
import TeamsPage from './pages/TeamsPage';
import GenerateFixturePage from './pages/GenerateFixturePage';
import EditTeamPage from './pages/EditTeamPage';
import InactivePlayersPage from './pages/PlayersPage';
import BlogPage from './pages/BlogPage';
import ShowPostsPage from './pages/ShowPostsPage';
import UpdateFixtures from './pages/UpdateFixtures';
import ScheduleMaker from './pages/ScheduleMaker'; // Importing the new ScheduleMaker page
import SeasonRulesPage from './pages/SeasonRulesPage';
import PlayoffManagementPage from './pages/PlayoffManagementPage';
import ProtectedRoute from './components/ProtectedRoute';
import Standings from './components/Standings'; // Ensure this is correctly imported

const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [themeMode, setThemeMode] = useState('light');

  const handleLoginSuccess = (token) => {
    setToken(token);
    localStorage.setItem('token', token);
  };

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
  };

  const toggleTheme = () => {
    setThemeMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    //console.log('Current token:', token); // Debugging log
  }, [token]);

  return (
    <ThemeProvider theme={themeMode === 'light' ? lightTheme : darkTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage onLoginSuccess={handleLoginSuccess} />} />
          <Route
            path="/"
            element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
          />
          <Route
            path="/seasons"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <SeasonsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/new"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <SeasonFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/edit"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <EditSeasonPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/manage"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <SeasonDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/teams"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <TeamsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/teams/:teamId/edit"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <EditTeamPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/generate-fixture"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <GenerateFixturePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/inactive-players"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <InactivePlayersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/blog/show"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <ShowPostsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/blog/create"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <BlogPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/update-fixtures"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <UpdateFixtures />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/standings"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <Standings />
              </ProtectedRoute>
            }
          />
       
          <Route
            path="/seasons/:seasonId/rules"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <SeasonRulesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/playoffs"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <PlayoffManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/seasons/:seasonId/schedule-maker"
            element={
              <ProtectedRoute token={token} onLogout={handleLogout} themeMode={themeMode} toggleTheme={toggleTheme}>
                <ScheduleMaker />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/seasons" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
